import Home from './assets/home/Home.vue'

export default [
  {
    path: '/',
    component: Home
  }
]



// WEBPACK FOOTER //
// ./src/routes.js